/**
 * @support-system/widget-sdk — React wrapper entry point (D-08).
 *
 * Exports:
 * - SupportWidget: Intercom-style floating messenger, role-guarded, error-bounded.
 *   Zero required props — reads identity from Refine useGetIdentity.
 *   Mount once inside the <Refine> provider tree (D-04).
 *
 * This is the only React-dependent entry point in the SDK.
 * The vanilla core lives in src/index.ts.
 */
import React from 'react';
import { WidgetErrorBoundary } from './WidgetErrorBoundary';
import { SupportWidgetInner } from './SupportWidget';

interface SupportWidgetProps {
    apiUrl: string;
    hubUrl: string;
    appVersion?: string;
}

/**
 * Floating help widget, isolated by an error boundary (HELP-04).
 * Mount once inside the <Refine> tree in App.tsx.
 */
export const SupportWidget: React.FC<SupportWidgetProps> = ({ apiUrl, hubUrl, appVersion }) => (
    <WidgetErrorBoundary>
        <SupportWidgetInner apiUrl={apiUrl} hubUrl={hubUrl} appVersion={appVersion} />
    </WidgetErrorBoundary>
);
